var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"},attrs:{"name":_vm.description}},[(_vm.name === 'github')?_c('img',{attrs:{"src":require("../assets/github.png"),"height":_vm.height}}):(_vm.name === 'githubw')?_c('img',{attrs:{"src":require("../assets/githubw.png"),"height":_vm.height}}):_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137828d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Icon.vue
// module id = 50
// module chunks = 0